<template>
    <v-dialog v-model="showDialog" width="600">
        <v-card class="pa-4">
            <v-row>
                <!--
                <v-col cols="6">
                    <v-card height="200px">
                        <v-card-title>
                            From Category
                        </v-card-title>
                        <v-card-text>
                            Create a new attribute group from another category.
                        </v-card-text>
                        <v-card-actions>
                            <category-search
                            v-on:CategorySelected = OnNewCategorySelected
                            >
                            </category-search>
                        </v-card-actions>
                    </v-card>
                </v-col>
                -->
                <v-col cols="12">
                    <v-card height="200px" flat>
                        <v-card-title>
                            From Attribute
                        </v-card-title>
                        <v-card-text>
                            Select an existing attribute that has been used elsewhere.
                        </v-card-text>
                        <v-card-actions>
                            <attribute-search
                            v-on:AttributeSelected = OnNewAttributeSelected
                            >
                            </attribute-search>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { mapState } from 'vuex'

import AttributeField from './AttributeField'
import AttributeSearch from './AttributeSearch'
import CategorySearch from '../category/CategorySearch'

export default {
    name: 'NewAttribute',
    components: {
        AttributeField,
        AttributeSearch,
        CategorySearch
    },
    computed: {

        ...mapState("assetxpstate", [
            "asset"
        ]),

    },
    props: {
        //Dialog to show new attribute dialog
        newAttributeDialog:
        {
            default : false,
            type : Boolean
        },
    },
    data: () => ({

        showDialog : false
        
    }),
    methods:{
        ...mapActions("assetxpstate", [
            "UpdateAssetAttributeMulti",
            "UpdateAssetAttribute",
            "UpdateAssetAttributeAsset",
            "AddAttributeToAsset",
            "RemoveAttributeFromAsset"
        ]),

       
        OnNewCategorySelected(evt) {
            var sendObj = new Object();

            sendObj.name = evt.name;
            sendObj.catFilters = [];
            sendObj.catFilters.push(evt.id);
            sendObj.attributeType = 3;
          
            sendObj.assetListingid = this.asset.assetListingid
            this.AddAttributeToAsset(sendObj).then( () =>{
                this.showDialog = false;
            });
        },
        OnNewAttributeSelected(evt) {
            var evtObj = evt;

            if(evt !== Object(evt)){
                evtObj = {name : evt, attributeType : 3};
            }
       
            evtObj.assetListingid = this.asset.assetListingid

            this.AddAttributeToAsset(evtObj).then( () =>{
                this.showDialog = false;
            });
        }
    },
    watch : {

        newAttributeDialog : {
            handler(newVal)
            {
                this.showDialog = newVal;
            }
        },
        showDialog : {
            handler(newVal)
            {
                if(newVal == false)
                {
                    this.$emit("OnDialogClose");
                }
            }
        }

    }
}
</script>